module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.accordionClasses
  }, _vm._l((_vm.items), function(item) {
    return _c('span', [_c('div', {
      staticClass: "title"
    }, [_c('i', {
      staticClass: "dropdown icon"
    }), _vm._v("\n            " + _vm._s(item.title) + "\n        ")]), _vm._v(" "), _c('div', {
      staticClass: "content"
    }, [_vm._v(_vm._s(item.content))])])
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-109447d3"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/croud-vue-semantic/src/Accordion.vue
// module id = 1444
// module chunks = 1